import { Routes } from '@angular/router';
import { PassageComponent } from './passage/passage.component';
import { PassageListComponent } from './passage-list/passage-list.component';

export const passageRoutes: Routes = [
  {
    path: 'passages',
    canActivate: [],
    data: {
      breadcrumb: {}
    },
    children: [
      {
        path: '',
        component: PassageListComponent,
        data: {
          type: 'list',
          breadcrumb: {
            bcType: 'Display',
            action: 'List',
            value: 'Passages',
            type: 'Passage'
          }
        }
      },
      {
        path: 'create',
        component: PassageComponent,
        data: {
          type: 'create',
          breadcrumb: {
            bcType: 'Display',
            action: 'Create',
            value: 'Passage',
            type: 'Passage'
          }
        }
      },
      {
        path: ':passageId',
        data: {
          breadcrumb: {
            bcType: 'LookUp',
            value: 'passageId',
            type: 'Passage'
          }
        },
        children: [
          {
            path: 'edit',
            component: PassageComponent,
            data: {
              type: 'edit',
              breadcrumb: {
                bcType: 'Display',
                action: 'Edit'
              }
            }
          }
        ]
      }
    ]
  },
];
